const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')


const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')


const monitoring_maping = () => import(/* webpackPrefetch: true */ '@/views/private/monitoring/maping/index.vue')
const monitoring_attendance = () => import(/* webpackPrefetch: true */ '@/views/private/monitoring/attendance/index.vue')
const monitoring_permission = () => import(/* webpackPrefetch: true */ '@/views/private/monitoring/permission/index.vue')


const unit_structure = () => import(/* webpackPrefetch: true */ '@/views/private/unit/structure/index.vue')
const unit_structure_regulation = () => import(/* webpackPrefetch: true */ '@/views/private/unit/structure/regulation/index.vue')
const unit_structure_officer = () => import(/* webpackPrefetch: true */ '@/views/private/unit/structure/officer/_id.vue')
const unit_structure_officer_regulation = () => import(/* webpackPrefetch: true */ '@/views/private/unit/structure/officer/regulation/_id.vue')
const unit_rule = () => import(/* webpackPrefetch: true */ '@/views/private/unit/rule/index.vue')
const unit_division = () => import(/* webpackPrefetch: true */ '@/views/private/unit/division/index.vue')

const unit_user_add = () => import(/* webpackPrefetch: true */ '@/views/private/unit/structure/officer/user/add/index.vue')
const unit_user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/unit/structure/officer/user/edit/_id.vue')


const attendance_presence = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/presence/index.vue')
const attendance_recap = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/recap/index.vue')
const attendance_late = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/late/index.vue')
const attendance_history = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/history/_id.vue')


const user = () => import(/* webpackPrefetch: true */ '@/views/private/user/index.vue')
const user_detail = () => import(/* webpackPrefetch: true */ '@/views/private/user/_id.vue')
const user_add = () => import(/* webpackPrefetch: true */ '@/views/private/user/add/index.vue')
const user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/user/edit/_id.vue')


const overtime_proposal = () => import(/* webpackPrefetch: true */ '@/views/private/overtime/proposal/index.vue')
const overtime_history = () => import(/* webpackPrefetch: true */ '@/views/private/overtime/history/index.vue')


const salary_now = () => import(/* webpackPrefetch: true */ '@/views/private/salary/now/index.vue')
const salary_month = () => import(/* webpackPrefetch: true */ '@/views/private/salary/month/index.vue')
const salary_month_detail = () => import(/* webpackPrefetch: true */ '@/views/private/salary/month/_id.vue')
const salary_history = () => import(/* webpackPrefetch: true */ '@/views/private/salary/history/index.vue')
const salary_history_detail = () => import(/* webpackPrefetch: true */ '@/views/private/salary/history/_id.vue')



const licensing_holiday = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/holiday/index.vue')
const licensing_permission = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/permission/index.vue')
const licensing_submission = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/submission/index.vue')


const report_data = () => import(/* webpackPrefetch: true */ '@/views/private/report/data/index.vue')
const report_summary = () => import(/* webpackPrefetch: true */ '@/views/private/report/summary/index.vue')
const report_history = () => import(/* webpackPrefetch: true */ '@/views/private/report/history/_id.vue')


const announcement = () => import(/* webpackPrefetch: true */ '@/views/private/announcement/index.vue')


const audit = () => import(/* webpackPrefetch: true */ '@/views/private/audit/index.vue')


const reimbursement_submission = () => import(/* webpackPrefetch: true */ '@/views/private/reimbursement/submission/index.vue')
const reimbursement_category = () => import(/* webpackPrefetch: true */ '@/views/private/reimbursement/category/index.vue')
const reimbursement_plafon = () => import(/* webpackPrefetch: true */ '@/views/private/reimbursement/plafon/index.vue')
const reimbursement_history = () => import(/* webpackPrefetch: true */ '@/views/private/reimbursement/history/index.vue')


const event = () => import(/* webpackPrefetch: true */ '@/views/private/event/index.vue')
const event_detail = () => import(/* webpackPrefetch: true */ '@/views/private/event/_id.vue')


const kpi_nilai = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/index.vue')
const kpi_nilai_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/_id.vue')

const kpi_nilai_tugas_utama = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/tugas/index.vue')
const kpi_nilai_tugas_utama_ketepatan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/tugas/ketepatan/_id.vue')
const kpi_nilai_tugas_utama_penilaian_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/tugas/penilaian/_id.vue')
const kpi_nilai_tugas_utama_skor_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/tugas/skor/_id.vue')


const kpi_nilai_pengembangan_diri = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/pengembangan/index.vue')
const kpi_nilai_pengembangan_diri_sertifikasi_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/pengembangan/sertifikasi/_id.vue')
const kpi_nilai_pengembangan_diri_pelatihan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/pengembangan/pelatihan/_id.vue')
const kpi_nilai_pengembangan_diri_keterlibatan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/pengembangan/keterlibatan/_id.vue')


const kpi_nilai_summary = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/summary/index.vue')
const kpi_nilai_summary_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/nilai/summary/_id.vue')

const kpi_master_kuisoner = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/master/kuisoner/index.vue')
const kpi_master_category = () => import(/* webpackPrefetch: true */ '@/views/private/kpi/master/category/index.vue')


const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },



  {
    path: "/profile",
    name: "Profile",
    component: profile,
    meta: {
      title: "Profile"
    }
  },



  {
    path: "/monitoring/maping",
    name: "Maping",
    component: monitoring_maping,
    meta: {
      title: "Maping"
    }
  },
  {
    path: "/monitoring/attendance",
    name: "Pegawai Presensi (Hari Ini)",
    component: monitoring_attendance,
    meta: {
      title: "Pegawai Presensi (Hari Ini)"
    }
  },
  {
    path: "/monitoring/permission",
    name: "Pegawai Izin (Hari Ini)",
    component: monitoring_permission,
    meta: {
      title: "Pegawai Izin (Hari Ini)"
    }
  },



  {
    path: "/unit/structure",
    name: "Struktur Organisasi",
    component: unit_structure,
    meta: {
      title: "Struktur Organisasi"
    }
  },
  {
    path: "/unit/structure/regulation",
    name: "Regulasi Struktur Organisasi",
    component: unit_structure_regulation,
    meta: {
      title: "Regulasi Struktur Organisasi"
    }
  },
  {
    path: "/unit/structure/officer/:id",
    name: "Struktur Pegawai",
    component: unit_structure_officer,
    meta: {
      title: "Struktur Pegawai"
    }
  },
  {
    path: "/unit/structure/officer/regulation/:id",
    name: "Regulasi Struktur Pegawai",
    component: unit_structure_officer_regulation,
    meta: {
      title: "Regulasi Struktur Pegawai"
    }
  },
  {
    path: "/unit/rule",
    name: "Aturan Perusahaan",
    component: unit_rule,
    meta: {
      title: "Aturan Perusahaan"
    }
  },
  {
    path: "/unit/division",
    name: "Data Unit / Divisi",
    component: unit_division,
    meta: {
      title: "Data Unit / Divisi"
    }
  },
  {
    path: "/unit/structure/officer/user/add",
    name: "Tambah Pegawai",
    component: unit_user_add,
    meta: {
      title: "Tambah Pegawai"
    }
  },
  {
    path: "/unit/structure/officer/user/edit/:id",
    name: "Ubah Pegawai",
    component: unit_user_edit,
    meta: {
      title: "Ubah Pegawai"
    }
  },



  {
    path: "/attendance/presence",
    name: "Data Presensi",
    component: attendance_presence,
    meta: {
      title: "Data Presensi"
    }
  },
  {
    path: "/attendance/recap",
    name: "Rekap Presensi",
    component: attendance_recap,
    meta: {
      title: "Rekap Presensi"
    }
  },
  {
    path: "/attendance/late",
    name: "Keterlambatan",
    component: attendance_late,
    meta: {
      title: "Keterlambatan"
    }
  },
  {
    path: "/attendance/history/:id",
    name: "Riwayat",
    component: attendance_history,
    meta: {
      title: "Riwayat"
    }
  },



  {
    path: "/user",
    name: "Data Pegawai",
    component: user,
    meta: {
      title: "Data Pegawai"
    }
  },
  {
    path: "/user/detail/:id",
    name: "Detail Pegawai",
    component: user_detail,
    meta: {
      title: "Detail Pegawai"
    }
  },
  {
    path: "/user/add",
    name: "Tambah Pegawai",
    component: user_add,
    meta: {
      title: "Tambah Pegawai"
    }
  },
  {
    path: "/user/edit/:id",
    name: "Ubah Pegawai",
    component: user_edit,
    meta: {
      title: "Ubah Pegawai"
    }
  },


  
  {
    path: "/overtime/proposal",
    name: "Ajuan Lembur",
    component: overtime_proposal,
    meta: {
      title: "Ajuan Lembur"
    }
  },
  {
    path: "/overtime/history",
    name: "Riwayat Lembur",
    component: overtime_history,
    meta: {
      title: "Riwayat Lembur"
    }
  },


  
  {
    path: "/salary/now",
    name: "Konfigurasi Gaji",
    component: salary_now,
    meta: {
      title: "Konfigurasi Gaji"
    }
  },
  {
    path: "/salary/month",
    name: "Gaji Bulanan",
    component: salary_month,
    meta: {
      title: "Gaji Bulanan"
    }
  },
  {
    path: "/salary/month/detail/:id",
    name: "Detail Gaji Bulanan",
    component: salary_month_detail,
    meta: {
      title: "Detail Gaji Bulanan"
    }
  },
  {
    path: "/salary/history",
    name: "Riwayat Gaji",
    component: salary_history,
    meta: {
      title: "Riwayat Gaji"
    }
  },
  {
    path: "/salary/history/detail/:id",
    name: "Detail Riwayat Gaji",
    component: salary_history_detail,
    meta: {
      title: "Detail Riwayat Gaji"
    }
  },


  {
    path: "/reimbursement/category",
    name: "Kategori",
    component: reimbursement_category,
    meta: {
      title: "Kategori"
    }
  },
  {
    path: "/reimbursement/plafon",
    name: "Plafon",
    component: reimbursement_plafon,
    meta: {
      title: "Plafon"
    }
  },
  {
    path: "/reimbursement/submission",
    name: "Pengajuan",
    component: reimbursement_submission,
    meta: {
      title: "Pengajuan"
    }
  },
  {
    path: "/reimbursement/history",
    name: "Riwayat",
    component: reimbursement_history,
    meta: {
      title: "Riwayat"
    }
  },



  {
    path: "/licensing/holiday",
    name: "Data Sisa Cuti",
    component: licensing_holiday,
    meta: {
      title: "Data Sisa Cuti"
    }
  },
  {
    path: "/licensing/submission",
    name: "Ajuan Izin & Cuti",
    component: licensing_submission,
    meta: {
      title: "Ajuan Izin & Cuti"
    }
  },
  {
    path: "/licensing/permission",
    name: "Riwayat Izin & Cuti",
    component: licensing_permission,
    meta: {
      title: "Riwayat Izin & Cuti"
    }
  },

  

  {
    path: "/report/data",
    name: "Data Laporan",
    component: report_data,
    meta: {
      title: "Data Laporan"
    }
  },
  {
    path: "/report/summary",
    name: "Summary Laporan",
    component: report_summary,
    meta: {
      title: "Summary Laporan"
    }
  },
  {
    path: "/report/history/:id",
    name: "Riwayat Laporan",
    component: report_history,
    meta: {
      title: "Riwayat Laporan"
    }
  },



  {
    path: "/event",
    name: "Agenda",
    component: event,
    meta: {
      title: "Agenda"
    }
  },
  {
    path: "/event/detail/:id",
    name: "Detail Agenda",
    component: event_detail,
    meta: {
      title: "Detail Agenda"
    }
  },



  {
    path: "/announcement",
    name: "Pengumuman",
    component: announcement,
    meta: {
      title: "Pengumuman"
    }
  },



  {
    path: "/audit",
    name: "Audit Trail",
    component: audit,
    meta: {
      title: "Audit Trail"
    }
  },




  {
    path: "/kpi/nilai",
    name: "Penilaian Pegawai",
    component: kpi_nilai,
    meta: {
      title: "Penilaian Pegawai"
    }
  },
  {
    path: "/kpi/nilai/summary/detail/:id",
    name: "Detail Penilaian Pegawai",
    component: kpi_nilai_detail,
    meta: {
      title: "Detail Penilaian Pegawai"
    }
  },

  {
    path: "/kpi/nilai/tugas_utama",
    name: "Tugas Utama",
    component: kpi_nilai_tugas_utama,
    meta: {
      title: "Tugas Utama"
    }
  },
  {
    path: "/kpi/nilai/tugas_utama/ketepatan/:id",
    name: "Detail Ketepatan Pekerjaan",
    component: kpi_nilai_tugas_utama_ketepatan_detail,
    meta: {
      title: "Detail Ketepatan Pekerjaan"
    }
  },
  {
    path: "/kpi/nilai/tugas_utama/penilaian/:id",
    name: "Detail Penilaian Atasan Langsung",
    component: kpi_nilai_tugas_utama_penilaian_detail,
    meta: {
      title: "Detail Penilaian Atasan Langsung"
    }
  },
  {
    path: "/kpi/nilai/tugas_utama/skor/:id",
    name: "Detail Skor Presensi",
    component: kpi_nilai_tugas_utama_skor_detail,
    meta: {
      title: "Detail Skor Presensi"
    }
  },


  {
    path: "/kpi/nilai/pengembangan_diri",
    name: "Pengembangan Diri",
    component: kpi_nilai_pengembangan_diri,
    meta: {
      title: "Pengembangan Diri"
    }
  },
  {
    path: "/kpi/nilai/pengembangan_diri/sertifikasi/:id",
    name: "Detail Sertifikasi Kompetensi",
    component: kpi_nilai_pengembangan_diri_sertifikasi_detail,
    meta: {
      title: "Detail Sertifikasi Kompetensi"
    }
  },
  {
    path: "/kpi/nilai/pengembangan_diri/pelatihan/:id",
    name: "Detail Pelatihan Sertifikat",
    component: kpi_nilai_pengembangan_diri_pelatihan_detail,
    meta: {
      title: "Detail Pelatihan Sertifikat"
    }
  },
  {
    path: "/kpi/nilai/pengembangan_diri/keterlibatan/:id",
    name: "Detail Keterlibatan Pegawai Dilingkungan Sekitar",
    component: kpi_nilai_pengembangan_diri_keterlibatan_detail,
    meta: {
      title: "Detail Keterlibatan Pegawai Dilingkungan Sekitar"
    }
  },


  {
    path: "/kpi/nilai/summary_score",
    name: "Summary Skor",
    component: kpi_nilai_summary,
    meta: {
      title: "Summary Skor"
    }
  },
  {
    path: "/kpi/nilai/summary/:id",
    name: "Summary Skor",
    component: kpi_nilai_summary_detail,
    meta: {
      title: "Summary Skor"
    }
  },
  {
    path: "/kpi/master/kuisoner",
    name: "Master Kuisoner",
    component: kpi_master_kuisoner,
    meta: {
      title: "Master Kuisoner"
    }
  },
  {
    path: "/kpi/master/category",
    name: "Master Kategori Penilaian",
    component: kpi_master_category,
    meta: {
      title: "Master Kategori Penilaian"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})